var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnigiri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:currentColor;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.584,320.545L355.625,76.401c-20.552-35.594-58.529-57.515-99.629-57.515 c-41.1,0-79.077,21.921-99.621,57.515L15.409,320.545c-10.27,17.8-15.413,37.67-15.409,57.53 c-0.004,19.854,5.139,39.722,15.404,57.524c20.556,35.586,58.534,57.515,99.638,57.515h281.916 c41.103,0,79.078-21.93,99.626-57.515C506.858,417.814,512,397.937,512,378.075C512,358.214,506.858,338.345,496.584,320.545z  M465.655,417.743c-14.169,24.534-40.361,39.65-68.697,39.65h-48.102V244.305H163.144v213.088h-48.102 c-28.336,0-54.535-15.117-68.705-39.65c-7.085-12.284-10.626-25.963-10.626-39.668c0-13.704,3.54-27.392,10.626-39.667 L187.303,94.257c14.162-24.542,40.35-39.651,68.693-39.651c28.339,0,54.535,15.109,68.701,39.651l140.958,244.152 c7.093,12.291,10.63,25.971,10.63,39.667C476.284,391.78,472.748,405.452,465.655,417.743z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnigiri);
export default __webpack_public_path__ + "static/media/onigiri.467519ddce7a823c52c8909b6bd64e5b.svg";
export { ForwardRef as ReactComponent };